<app-webpage-analytics></app-webpage-analytics>

<app-progress-spinner [color]="color" [mode]="mode" [value]="value" [backdropEnabled]="true"
	[positionGloballyCenter]="true" [displayProgressSpinner]="displayProgressSpinner"></app-progress-spinner>
    
<div class="flex">
    <div class="ontario-row recordContainer">

        <app-breadcrumbs></app-breadcrumbs>

        <div class="divider">
            <h1>{{ 'drill.hole.summary.for' | translate | async }} {{ tech_id }}</h1>
        </div>

        <app-copy-to-clipboard [index]="databaseIndex" [fileNumber]="tech_id"></app-copy-to-clipboard>

        <ng-template [ngTemplateOutlet]="detailsTable"></ng-template>

        <div class="ontario-accordions__container">
            <div class="ontario-accordion__controls">
                <button class="ontario-accordion__button--expand-all" aria-expanded="false">
                    <span class="ontario-accordion--expand-open-all">{{ 'expand.all' | translate | async }}</span>
                    <span class="ontario-accordion--expand-close-all">{{ 'collapse.all' | translate | async }}</span>
                </button>
            </div>
            <div *ngIf="(drillHoles$ | async)" class="ontario-accordion" id="accordion-1">
                <button class="ontario-accordion__button" id="accordion-button-id-1" aria-controls="accordion-content-1"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'drill.holes' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-1" aria-labelledby="accordion-button-id-1" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="drillHolesTable"></ng-template>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-2">
                <button class="ontario-accordion__button" id="accordion-button-id-2" aria-controls="accordion-content-2"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'report.an.error' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-2" aria-labelledby="accordion-button-id-2" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'drill.hole.report.an.error.text' | translate | async }}">
                            {{ 'drill.hole.report.an.error.text' | translate | async }}
                    </div>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-3">
                <button class="ontario-accordion__button" id="accordion-button-id-3" aria-controls="accordion-content-3"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'terms.of.use' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-3" aria-labelledby="accordion-button-id-3" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'terms.of.use.link' | translate | async }}">
                            {{ 'terms.of.use.link' | translate | async }}
                        </p>
                    </div>
                </section>
            </div>
        </div>

        <div class="mt-4 divider contactInformationContainer">
            <div class="flex mb-4 ">
                <h3 class="contactInformationTitle">
                    {{ 'contact.information' | translate | async }}
                </h3>   
                <p class="contactInformationValue">

                    {{ 'contact.text' | translate | async }}

                    <a target="_blank" 
                        href="https://www.infogo.gov.on.ca/infogo/#orgProfile/{{contact_rgp.contact}}/en">
                        {{ contact_rgp.rgp_district }}
                    </a>  
                </p> 
            </div>
        </div>

        <ng-template #detailsTable>
            <div>
                <div>
                    <h2 class="mt-3 mb-3">{{ 'drill.hole.details' | translate | async }}</h2>
                </div>
                <div class="detailsContainer">
                    <div class="flex">
                        <div *ngIf="company" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'company' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ company | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ company | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="propertyName" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'property.name' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ propertyName | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ propertyName | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="township" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'township.area' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ township | highlight : this.searchTerms }}">
                                {{ township | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="nts" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'nts' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ nts | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ nts | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="rgpDistrict" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'resident.geologist.district' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ rgpDistrict | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ rgpDistrict | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="yearDrilled" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'year.drilled' | translate | async}}:</p>
                            <p class="recordValue" innerHTML="{{ yearDrilled | notApplicablePipe | async }}">
                                {{ yearDrilled | notApplicablePipe | async }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'assessment.file' | translate | async}}:</p>
                            <a target="_blank" 
                                class="recordValue"
                                innerHTML="{{ tech_id | highlight : this.searchTerms }}"
                                href="{{this.assessmentPersistentLink}}">
                                {{ tech_id | highlight : this.searchTerms }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #drillHolesTable>
            <div>
                <div>
                    <div>
                        <h3 class="mb-2">
                            {{ 'contents' | translate | async }}
                        </h3>
                    </div>
                    <div class="ontario-table-container">
                        <div class="ontario-table-div mb-0">
                            <table class="flex-child" tabindex="0">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'hole.type' | translate | async }}</th>
                                        <th scope="col">{{ 'hole.id' | translate | async }}</th>
                                        <th scope="col">{{ 'company.hole.id' | translate | async }}</th>
                                        <th scope="col">{{ 'township.area' | translate | async }}</th>
                                        <th scope="col">{{ 'utm.datum' | translate | async }}</th>
                                        <th scope="col">{{ 'utm.zone' | translate | async }}</th>
                                        <th scope="col">{{ 'easting' | translate | async }}</th>
                                        <th scope="col">{{ 'northing' | translate | async }}</th>
                                        <th scope="col">{{ 'dip' | translate | async }}</th>
                                        <th scope="col">{{ 'azimuth' | translate | async }}</th>
                                        <th scope="col">{{ 'overburden.depth' | translate | async }}</th>
                                        <th scope="col">{{ 'length' | translate | async }}</th>
                                        <th scope="col">{{ 'units' | translate | async }}</th>
                                        <th scope="col">{{ 'elements' | translate | async }}</th>
                                        <th scope="col">{{ 'drill.core.storage.site' | translate | async }}</th>
                                        <th scope="col">{{ 'comments' | translate | async }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let drill_hole of drillHoles$ | async">
                                        <td scope="row" innerHTML="{{ drill_hole._source.dh_type | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.dh_type | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.id | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.id | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.company_hole_id | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.company_hole_id | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.township | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.township | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.utm_datum | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.utm_datum | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.dip | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.dip | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.azimuth | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.azimuth | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.overburden | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.overburden | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.length | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.length | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.length_unit | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.length_unit | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.elements | commaSeparatedPipe:'description' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.elements | commaSeparatedPipe:'description' | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.drill_core | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.drill_core | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ drill_hole._source.comments | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ drill_hole._source.comments | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>

    <!-- Scroll Button -->
    <button onClick="scrollToTop()" class="ontario-back-to-top--default">
        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-arrow-up"></use>
        </svg>
        {{ 'top' | translate | async }}
    </button>
    
</div>